import React, { useEffect, useState } from 'react';
import { Grid, TextField } from '@material-ui/core';
// import FormControlLabel from '@mui/material/FormControlLabel';
// import Checkbox from '@mui/material/Checkbox';
// import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import authService from '../services/auth.service';
import swal from 'sweetalert';
import { useNavigate } from 'react-router';
import imag from './image.svg';
import { Divider, Box, InputLabel, Button, FormControlLabel, Checkbox, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

const Login = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });
    const [rememberMe, setRememberMe] = useState(false);
    // const avatarStyle = { backgroundColor: '#1bbd7e' };
    // const btnstyle = { margin: '8px 0' };
    const handleChange = e => {
        e.persist();
        setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSubmit = () => {
        authService.login(formData.email, formData.password).then(data => {
            if (data.access_token) {
                if (rememberMe) {
                    localStorage.setItem('rememberedEmail', formData.email);
                    localStorage.setItem('rememberedPassword', formData.password);
                } else {
                    localStorage.removeItem('rememberedEmail');
                    localStorage.removeItem('rememberedPassword');
                }

                const userStr = localStorage.getItem('user');
                let user = null as { user_info: { role: string; id: number }; access_token: string } | null;
                if (userStr) user = JSON.parse(userStr);
                if (user && user.access_token) {
                    const { role: userRole, id: userId } = user.user_info;
                    var library = {
                        SysAdmin: '/library',
                        Expert: '/expert-library',
                        'Customer Admin': '/customer-library',
                        'Customer User': '/customer-library'
                    };
                    navigate(library[userRole]);
                } else {
                    navigate('/profile');
                }
            } else {
                swal({
                    title: 'Did not Login?',
                    text: data.response.data.message,
                    icon: 'error'
                });
            }
        });
    };

    const handleRegister = () => {
        navigate('/register');
    };

    useEffect(() => {
        const userStr = localStorage.getItem('user');
        const rememberedEmail = localStorage.getItem('rememberedEmail');
        const rememberedPassword = localStorage.getItem('rememberedPassword');

        if (userStr) {
            navigate('/profile');
        }

        if (rememberedEmail && rememberedPassword) {
            setFormData({ email: rememberedEmail, password: rememberedPassword });
            setRememberMe(true);
        }

        //eslint-disable-next-line
    }, []);

    return (
        <Grid container>
            <Grid
                xs={12}
                md={6}
                item
                className="d-flex align-items-center justify-content-center flex-column"
                style={{ height: '100vh' }}
            >
                <Box
                    className="d-flex align-items-center justify-content-center flex-column"
                    sx={{
                        width: {
                            md: '60%',
                            sm: '70%',
                            xs: '80%'
                        }
                    }}
                    height="100%"
                >
                    <Typography
                        variant="h3"
                        align="left"
                        sx={{
                            color: '#0466C8',
                            width: {
                                md: '80%',
                                sm: '90%',
                                xs: '98%'
                            },
                            fontWeight: 'bold'
                        }}
                    >
                        Login
                    </Typography>
                    <Divider
                        color="warning"
                        sx={{
                            width: {
                                md: '80%',
                                sm: '90%',
                                xs: '98%'
                            },
                            background: '#0466C8'
                        }}
                        className=" mx-auto my-2"
                    />
                    <Typography
                        align="left"
                        sx={{
                            color: '#868E96',
                            width: {
                                md: '80%',
                                sm: '90%',
                                xs: '98%'
                            },
                            fontWeight: '500',
                            fontSize: '1rem'
                        }}
                        className="text-xl"
                    >
                        Welcome Back! Please enter you details
                    </Typography>

                    <Box
                        className="d-flex flex-column pb-4"
                        sx={{
                            width: {
                                md: '80%',
                                sm: '90%',
                                xs: '98%'
                            }
                        }}
                        gap={3}
                    >
                        <Box className="mt-5  d-flex flex-column ">
                            <InputLabel className="mb-3" style={{ textAlign: 'left', color: '#242424' }}>
                                Email
                            </InputLabel>
                            <TextField
                                placeholder="Enter email address"
                                fullWidth
                                required
                                name="email"
                                variant="outlined"
                                value={formData.email}
                                onChange={handleChange}
                            />
                        </Box>
                        <Box className="mt-3  d-flex flex-column ">
                            <InputLabel className="mb-3" style={{ textAlign: 'left', color: '#242424' }}>
                                Password
                            </InputLabel>
                            <TextField
                                placeholder="Enter password"
                                type="password"
                                fullWidth
                                required
                                variant="outlined"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                            />
                        </Box>
                        <Box className="d-flex justify-content-between align-items-center">
                            <FormControlLabel
                                control={
                                    <Checkbox checked={rememberMe} onChange={e => setRememberMe(e.target.checked)} />
                                }
                                label="Remember me"
                            />
                            <Link
                                to={'/forgot-password'}
                                className=" text-align-right cursor-pointer"
                                style={{ color: '#0466c8' }}
                            >
                                Forgot Password
                            </Link>
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            width: {
                                md: '80%',
                                sm: '90%',
                                xs: '98%'
                            }
                        }}
                    >
                        <Button
                            fullWidth
                            // disabled={isLoading}
                            type="submit"
                            variant="contained"
                            className="mr-2 text-capitalize p-3 text-lg"
                            style={{ backgroundColor: '#0466C8' }}
                            onClick={() => handleSubmit()}
                        >
                            Sign in
                        </Button>
                    </Box>
                    <Box
                        className="mt-3"
                        sx={{
                            width: {
                                md: '80%',
                                sm: '90%',
                                xs: '98%'
                            }
                        }}
                    >
                        <Button
                            fullWidth
                            // disabled={isLoading}
                            type="submit"
                            variant="outlined"
                            className="mr-2 text-capitalize p-3 text-lg"
                            style={{ borderColor: '#0466c8', color: '#0466c8' }}
                            onClick={() => handleRegister()}
                        >
                            Register
                        </Button>
                    </Box>
                </Box>
            </Grid>
            <Grid item xs={12} md={6} style={{ height: '100vh' }}>
                <Box className="h-100 position-relative">
                    <Box
                        className="glass p-4 w-75  position-absolute  text-white  text-align-center"
                        sx={{ transform: 'translate(-50%,-50%)', bottom: 0, left: '50%', fontSize: '1.38rem' }}
                    >
                        A one stop solution to all your Auditing & <br />
                        Compliance needs
                    </Box>
                    <img
                        src={imag}
                        alt="image"
                        style={{
                            height: '100%',
                            width: '100%',
                            margin: 0,
                            zIndex: -100,
                            objectFit: 'cover',
                            objectPosition: 'center'
                        }}
                    />
                </Box>
            </Grid>
        </Grid>
    );
};

export default Login;
